export default function CtaSection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20composition%20with%20soft%20coral%20amber%20and%20cream%20gradients%2C%20smooth%20flowing%20shapes%2C%20minimalist%20modern%20design%2C%20warm%20inviting%20atmosphere%2C%20gentle%20light%20diffusion%2C%20clean%20elegant%20aesthetic&width=1600&height=700&seq=cta-bg-01&orientation=landscape"
          alt="CTA 背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-900/70 to-background-900/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开启漫画之旅了吗？
        </h2>
        <p className="text-background-200/80 text-sm md:text-base max-w-lg mx-auto mb-8">
          立即访问禁漫天堂，海量漫画资源等你来探索。安全、快速、便捷的漫画阅读体验，从这里开始。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3.5 bg-accent-500 text-background-50 rounded-lg text-base font-medium hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-rocket-line mr-2"></i>
            立即进入禁漫天堂
          </a>
          <a
            href="#"
            className="px-8 py-3.5 border-2 border-background-50/30 text-background-50 rounded-lg text-base font-medium hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-smartphone-line mr-2"></i>
            下载移动端APP
          </a>
        </div>
      </div>
    </section>
  );
}